import { Container, Service } from 'typedi';
import {
    ActionID,
    AppIdentifiers,
    AreaType,
    IPerformActionTopicPayload,
    TriggerType,
} from '@sparkware/uc-sdk-core';
import { IRegularLoginResponseModel } from '../authentication/models';
import { PendingService } from '../pending/pending.service';
import { Utils } from '../utils';
import { WindowToken } from '../../injection-tokens';
import { LoaderManager } from '../../loaders/LoaderManager';
import { IActionHandlerFactory } from '../action-handler/models/IActionHandlerFactory';
import { TokenType } from '../../models/enums/general-enums';

@Service()
export class WebLoginErrorHandler {
    private readonly _window: Window;
    private readonly _utils: Utils;
    private readonly _pendingService: PendingService;

    private get _actionHandlerFactoryPromise(): Promise<IActionHandlerFactory> {
        return LoaderManager.Instance.ActionHandlerFactoryLoader.Instance;
    }

    constructor() {
        this._window = Container.get(WindowToken);
        this._utils = Container.get(Utils);
        this._pendingService = Container.get(PendingService);
    }

    public Handle = async (
        result: IRegularLoginResponseModel,
        hideWebLogin: () => Promise<any>,
    ): Promise<void> => {
        switch (result?.ErrorCode) {
            case 50:
                await hideWebLogin();
                this._handlePending(result);
                break;

            case 5000:
                await hideWebLogin();
                await this._handleClosedAccount(result);
                break;

            default:
                break;
        }
    };

    private _handlePending = (result: IRegularLoginResponseModel): void => {
        if (!result?.PendingToken) return;

        this._pendingService.displayPendingOnLogin(result.PendingToken, result.SpecificNavigation);
    };

    private _handleClosedAccount = async (result: IRegularLoginResponseModel): Promise<void> => {
        if (!result?.FullResponse?.AccessToken) return;

        const action: IPerformActionTopicPayload = {
            actionID: ActionID.closedAccounts,
            correlationID: this._utils.generateCorrelationID(),
            launchInfo: {
                businessCorrelationID: this._utils.generateCorrelationID(),
                sequentialCorrelationID: 1,
                channel: {
                    area: AreaType.button,
                    source: 'Unified Client',
                    element: 'Default',
                },
                trigger: TriggerType.userSelection,
                sourceAppID: AppIdentifiers.UnifiedClient,
                sourceAppVersion: '0.0.0',
                clientVersion: this._window.pageContextManager.getDeviceData().clientVersion,
                appSpecificParameters: {
                    GetTokenResponse: {
                        Token: result.FullResponse.AccessToken,
                        TokenType: result.FullResponse.AccessTokenType,
                    },
                },
            },
        };

        const actionHandlerFactory = await this._actionHandlerFactoryPromise;
        await actionHandlerFactory.performAction(action);
    };
}
